// 0(pending, 미클레임)은 활성이 아니다 — pending 잡을 활성으로 보면
// retryVideoEncodingJob이 video 상태 리셋(update 경로)을 영원히 못 하고
// requeue 후 show_video가 processing에 남은 잡을 고칠 방법이 없어진다.
const ACTIVE_ENCODING_JOB_STATUSES = new Set([1, 2, 3, 4]);
const ACTIVE_BROWSE_ENCODING_JOB_STATUSES = new Set([
  "queued",
  "leased",
  "downloading",
  "encoding",
  "uploading"
]);

export function isActiveEncodingJobStatus(status: unknown) {
  return typeof status === "number" && Number.isInteger(status) && ACTIVE_ENCODING_JOB_STATUSES.has(status);
}

export function isActiveBrowseEncodingJobStatus(status: string | null | undefined) {
  return typeof status === "string" && ACTIVE_BROWSE_ENCODING_JOB_STATUSES.has(status);
}

const NON_RETRYABLE_ENCODING_FAILURE_MARKERS = [
  "hard-good split contract violated",
  "split GBDT label conflicts unresolved",
  "split GBDT validation failed",
  "split runtime code hash mismatch",
  "split model/report hash mismatch",
  "split production dry-run/model hash mismatch",
  "verified global split artifact is missing",
  "global split report has no successful production dry-run",
  "global split model artifact gate failed",
  "global cumulative split model does not cover current hard labels"
];

export function isNonRetryableEncodingFailure(message: string) {
  return NON_RETRYABLE_ENCODING_FAILURE_MARKERS.some((marker) => message.includes(marker));
}
